// import React from "react";
// import "./Compatibility.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

// const compatibilityData = [
//   {
//     title: "Flat Platform",
//     image: "/assets/images/hospitality/bed1.png",
//     compatible: true,
//   },
//   {
//     title: "Slatted Bed",
//     image:  "/assets/images/hospitality/bed2.png",
//     compatible: true,
//   },
//   {
//     title: "Boxspring/Foundation",
//     image: "/assets/images/hospitality/bed3.png",
//     compatible: true,
//   },
//   {
//     title: "Adjustable Bed",
//     image: "/assets/images/hospitality/bed4.png",
//     compatible: false,
//   },
// ];

// const Compatibility = () => {
//   return (
//     <section className="compatibility_section">
//       <div className="container">
//         <h2 className="compatibility_heading">Compatibility</h2>
//         <div className="compatibility_grid">
//           {compatibilityData.map((item, index) => (
//             <div key={index} className="compatibility_card">
//               <div className="compatibility_image_wrapper">
//                 <img
//                   src={item.image}
//                   alt={item.title}
//                   className="compatibility_image"
//                 />
//                 <div
//                   className={`compatibility_icon ${
//                     item.compatible ? "compatible" : "not_compatible"
//                   }`}
//                 >
//                   <FontAwesomeIcon
//                     icon={item.compatible ? faCheck : faXmark}
//                     size="sm"
//                   />
//                 </div>
//               </div>
//               <div className="compatibility_title">{item.title}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Compatibility;

import React from "react";
import "./Compatibility.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import Common_Title from "../../common_components/common_title/Common_Title";

const compatibilityData = [
  {
    title: "Flat Platform",
    image: "/assets/images/hospitality/bed1.png",
    compatible: true,
  },
  {
    title: "Slatted Bed",
    image: "/assets/images/hospitality/bed2.png",
    compatible: true,
  },
  {
    title: "Boxspring/Foundation",
    image: "/assets/images/hospitality/bed3.png",
    compatible: true,
  },
  {
    title: "Adjustable Bed",
    image: "/assets/images/hospitality/bed4.png",
    compatible: false,
  },
];

const Compatibility = () => {
  return (
    <section className="compatibility_section luxery-section">
      <div className="container">
        {/* <h2 className="compatibility_heading">Compatibility</h2> */}
        <div className="title_with_line">
          <Common_Title title="Compatibility" />
        </div>

        <div className="row justify-content-center">
          {compatibilityData.map((item, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-6 mb-4">
              <div className="compatibility_card">
                <div className="compatibility_image_wrapper">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="compatibility_image"
                  />
                  <div
                    className={`compatibility_icon ${
                      item.compatible ? "compatible" : "not_compatible"
                    }`}
                  >
                    <FontAwesomeIcon
                      icon={item.compatible ? faCheck : faXmark}
                      size="sm"
                    />
                  </div>
                </div>
                <div className="compatibility_title">
                  <p className="inner_text">{item.title} </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Compatibility;
